<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="rule-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <h5 class="title"></h5>
                    <div class="rule-view">
                        <div class="text-item">
                            <div class="tag">1</div>
                            <div class="content">
                                邀请近3期未在阿斗赶集消费过的玩家进行绑定，绑定成功后，双方均可获得【阿斗互助礼】*1（最多可绑定3位好友，获得3份奖励）
                                <div class="goods-detail">
                                    <div class="goods-wrapper">
                                        <div class="goods-pic" v-tips="'PI15'"><game-item :locked="true" :id="'PI15'" :num="1"></game-item></div>
                                    </div>  
                                </div>                                 
                            </div>
                           
                        </div>
                        <div class="text-item">
                            <div class="tag">2</div>
                            <div class="content">
                                本人与被邀请的玩家在本次阿斗同时消费，可获得【阿斗凯旋礼】（最多可邀请3位好友，获得3份奖励）
                                <div class="goods-detail">
                                    <div class="goods-wrapper">
                                        <div class="goods-pic" v-tips="'PI16'"><game-item :locked="true" :id="'PI16'" :num="1"></game-item></div>
                                    </div>  
                                </div>                                
                            </div>

                        </div>
                        <div class="text-item">
                            <div class="tag">3</div>
                            <p>邀请的好友必须满足条件：近3期未在阿斗消费，否则邀请失败</p>
                        </div>
                        <div class="text-item">
                            <div class="tag">4</div>
                            <p>玩家可以同时邀请好友绑定自己，也可接受绑定，但只能<b>接受1人</b>的绑定邀请</p>
                        </div>
                    </div>
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>
    .dialog-view{
        z-index: 100;
    }

    .rule-modal{
        width: 625px;
        height: 570px;
        background-image: url(~@/assets/images/modal/bg-modal-w12-rule.png);        
    }

    .title{
        width: 516px;
        height: 51px;
        margin: 0 auto 10px;
        background-image: url(~@/assets/images/modal/title-w12-rule.png);  
    }

    .rule-view{
        padding: 0 42px;
        font-size: 21px;
        color: #696560;

        .text-item{
            position: relative;
            padding-left: 40px;

            .tag{
                position: absolute;
                left: 0;
                top: 0;
                width: 34px;
                height: 34px;
                line-height: 34px;
                text-align: center;
                background-color: #efe6d7;
                color: #8e6e25;
                border: 1px solid #c0b498;
                border-radius: 3px;
            }
        }

        .content{
            line-height: 1.8;
            margin-bottom: 20px;            
        }

        p{
            line-height: 1.8;
            margin-bottom: 20px;
        }

        b{
            color: #c69628;
        }
    } 
    
    .goods-detail{
        display: inline-block;
        vertical-align: middle;        
        // .goods-wrapper{
        //     display: flex;
        //     justify-content: center;
        //     align-items: center;
        //     position: relative;
        //     width: 118px;
        //     height: 118px;
        //     margin: 0 auto;
        //     background-image: url(~@/assets/images/shop/bg-item.png);
        // }

        .goods-pic{
            width: 46px;
            height: 46px;
            border: 2px solid #ccae62;
        }
    }
  
</style>

<script>
export default {
    data () {
        return {
            visible : false,
            text : '',
            rid : 1,
        }
    },  
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
    },
    methods : {
        destroyElement () {
            //this.$be_free();
            document.body.style.overflow = ''; // 出现滚动条
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },        
        closeModal(){
            this.destroyElement()
        },       
    },    
}
</script>